<ng-container *ngIf="filterType === 'string'">
	<span [class]="mode">
		<ws-input
			[disabled]="disabled || !isSearchable"
			[placeholder]="placeholder || ''"
			[(result)]="textValue"
			(resultChange)="onTextInput($event)"
			(enterKeyDown)="onTextEnter()"
		></ws-input>
	</span>
</ng-container>

<ng-container *ngIf="filterType === 'select'">
	<span class="cell select-filter">
		<ws-select
			[disabled]="disabled || !isSearchable"
			[options]="selectOptions"
			value="value"
			display="label"
			[(result)]="selectValue"
			(resultChange)="onSelectChange($event)"
			[optionTranslate]="true"
		></ws-select>
	</span>
</ng-container>
